import { ExceptionApiAccessTokenExpired } from '~/data/exceptions/ExceptionApiAccessTokenExpired'
import { ExceptionApiForbidden } from '~/data/exceptions/ExceptionApiForbidden'

export const useAuthStore = defineStore('authStore', {
  state: () => ({
    _userInfo: null as IArtistInfoSelect.ResponseItem | null,
    // 서버가 토큰을 거부한 요청. 서버에서 쿠키를 지워도 같은 요청 안에서는 요청 헤더의 쿠키가 계속 읽히므로
    // 이 플래그로 isLogin 을 즉시 false 로 만든다 (WP-6337)
    _tokenRejected: false,
  }),
  getters: {
    isLogin: (state) => {
      return (
        !state._tokenRejected &&
        !!useServiceCookie(COOKIE_NAME.ACCESS_TOKEN).get()
      )
    },
    accessToken: () => {
      return useServiceCookie(COOKIE_NAME.ACCESS_TOKEN).get()
    },
    userInfo: (state) => state._userInfo,
  },
  actions: {
    setTokens(tokens: ILoginInsert.ResponseItem) {
      this._tokenRejected = false
      useServiceCookie(COOKIE_NAME.ACCESS_TOKEN, {
        expires: new Date(tokens.expiredAt),
      }).set(tokens.accessToken)
    },

    removeTokens() {
      useServiceCookie(COOKIE_NAME.ACCESS_TOKEN).remove()
    },

    async login(id: string, password: string) {
      const $nuxt = useNuxtApp()
      const response = await $nuxt.$apiService.authApi.login(id, password)
      this.setTokens(response)
      return response
    },
    async logout() {
      try {
        const $nuxt = useNuxtApp()
        await $nuxt.$apiService.authApi.logout()
      } catch (_error) {
        // 별도의 처리 로직 없음
      } finally {
        this.removeTokens()
        this._userInfo = null
      }
    },
    async getUserInfo() {
      const $nuxt = useNuxtApp()
      try {
        const response = await $nuxt.$apiService.artistApi.selectArtistInfo()
        this._userInfo = response
      } catch (error) {
        // refresh token 로직이 없으므로 토큰 거부(401/403/500-Forbidden) = 로그아웃 처리 (WP-6337)
        if (
          error instanceof ExceptionApiAccessTokenExpired ||
          error instanceof ExceptionApiForbidden
        ) {
          // await 이후라 서버에서는 Nuxt 컨텍스트가 끊기므로 runWithContext 로 useCookie 를 호출한다
          await $nuxt.runWithContext(() => this.removeTokens())
          this._userInfo = null
          this._tokenRejected = true
        }
        throw error
      }
    },
  },
})
